/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import css from '@mybook/audio-player-js/dist/style.css';


export default class {
  constructor(props) {
    Object.assign(this, props);
    const bookMarkApiUrl = 'audio-auto-bookmarks/';
    const audioStatisticsApiUrl = 'audio-statistics/';
    this.playerUrls = {
      getBook: (bookId) => ({ url: `books/${bookId}/`, version: '4' }),
      getAutoBookmark: (bookId) => ({ url: `${bookMarkApiUrl}${bookId}/` }),
      setAutoBookmark: () => ({ url: bookMarkApiUrl }),
      setStatistics: () => ({ url: audioStatisticsApiUrl }),
    };
  }

  _playerOptions() {
    const { trialMessage, isActiveSubscription } = this;
    return {
      isEnableAutoplay: true,
      TrialMessage: () => <div>{trialMessage}</div>,
      isFreeFragment: !isActiveSubscription,
      onPlay: this.handleTimeUpdate,
      styles: {
        almostWhite: '#F4F4F4',
        primary: '#be5b04',
        gray: '#545454',
        borderRadius: '12px',
      },
    };
  }

  _bookAdaptor(book) {
    const {
      absolute_url,
      default_cover,
      bookfiles,
      main_author: { absolute_url: authorLink, cover_name },
    } = book;

    const bookLink = absolute_url;
    const authorName = cover_name;
    delete book.bookfiles;

    return {
      ...book,
      default_image: `/c/256x256/${default_cover}`,
      files: bookfiles,
      bookLink,
      authorLink,
      authorName,
    };
  }

  handleTimeUpdate() {
    // handleTimeUpdate
  }

  player() {
    if (__RENDER__ === 'client') {
      const Player = require('@mybook/audio-player-js').default;
      const {
        bookId, hidePlayer, handlePlay,
      } = this;

      window.player = {};
      window.player.trackingFunctions = {
        onKeyPause: () => {
          // pause
        },
        onKeyPlay: () => {
          handlePlay && handlePlay();
        },
      };

      return (
        <Player
          bookId={bookId}
          hidePlayer={hidePlayer}
          Link={Link}
          {...this._playerOptions()}
          urls={this.playerUrls}
          bookAdaptor={this._bookAdaptor} />
      );
    }

    return <Fragment />;
  }
};
